import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useConfig } from '../context/ConfigContext';

export default function Terms() {
  const { contact } = useConfig();
  const today = new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' });
  return (
    <div className="bg-white">
      <Header/>
      <section className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-[#8BC53F] font-bold tracking-widest text-sm mb-3">LEGAL</p>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-slate-900">Terms of Service</h1>
        <p className="text-slate-500 mt-2">Effective {today}</p>
        <div className="mt-8 space-y-6 text-slate-700 leading-relaxed">
          <p>By using XP-PRO (“Service”) provided by Xpertpests Solutions you agree to these Terms.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">1. License</h2>
          <p>We grant you a non-transferable license to use the Service for your pest-control business operations during the paid subscription period.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">2. Subscription &amp; Billing</h2>
          <p>Subscriptions renew automatically until cancelled. Cancel anytime from your account or via Google Play. No refunds for partial months.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">3. Acceptable Use</h2>
          <p>Do not (a) reverse-engineer the Service, (b) resell access, (c) use it for unlawful purposes, or (d) attempt to access other tenants’ data.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">4. Data Ownership</h2>
          <p>You own your business data. We act as processor. On termination we provide a 30-day window to export.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">5. Limitation of Liability</h2>
          <p>The Service is provided “as is.” To the extent permitted by law, our aggregate liability is limited to fees paid in the prior 12 months.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">6. Governing Law</h2>
          <p>These Terms are governed by the laws of the State of California, USA.</p>
          <h2 className="text-2xl font-bold text-slate-900 mt-8">7. Contact</h2>
          <p>{contact.email} · {contact.phone1} · {contact.address}</p>
          <div className="mt-10 pt-6 border-t border-slate-200 text-sm text-slate-500">See also our <Link to="/privacy" className="text-[#8BC53F] font-semibold underline">Privacy Policy</Link>.</div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}
